const spotifyConfig = {
  clientId: process.env.REACT_APP_SPOTIFY_CLIENT_ID || 'd27bcf074c0e49c7942d9610a6cf570b',
  redirectUri: process.env.NODE_ENV === 'production' 
    ? 'https://warriorwalkupmusic.com' 
    : 'http://127.0.0.1:3000',
  scopes: [
    'streaming',
    'user-read-email',
    'user-read-private',
    'user-read-playback-state',
    'user-modify-playback-state'
  ]
};

export default spotifyConfig;